import { useNavigate } from "react-router-dom";

const ManageSparePartsDetail = () => {
  const navigate = useNavigate();

  const sparePartInfo = [
    { label: "Spare Part Name", value: "Bosch Break Pad" },
    {
      label: "Price",
      value: (
        <>
          <strong className="c_primary">$5,000</strong>{" "}
          <del>$6,500</del>
        </>
      ),
    },
    { label: "Category", value: "Car Accessories" },
    { label: "Sub Category", value: "Accessories" },
    { label: "OEM Number", value: "OEM-234567" },
    { label: "Condition", value: "New" },
    {
      label: "Small Description",
      value:
        "The Ducati Streetfighter is a bold and aggressive motorcycle that embodies the spirit of naked bike performance. With its powerful 1,103cc V4 engine, it produces a thrilling 208 horsepower, ensuring an exhilarating ride on both city streets and winding roads.",
    },
    {
      label: "Full Description",
      value:
        "The Caterpillar Excavator 320 is a robust and versatile machine designed for heavy-duty construction tasks. Equipped with a powerful engine, it delivers exceptional performance, making it ideal for digging, lifting, and moving materials on any job site. The 320 features a durable undercarriage and a spacious cab, providing operators with comfort and visibility while working long hours. Its advanced hydraulic system ensures precise control and efficiency, allowing for smooth operation in various terrains. With a range of attachments available, the Caterpillar Excavator 320 can adapt to different tasks, from trenching to demolition. This excavator is built to withstand the rigors of tough environments, making it a reliable choice for contractors looking to maximize productivity.",
    },
    { label: "Created Date", value: "01 March 2025" },
  ];

  const compatibilityInfo = [
    { label: "Brand / Make", value: "Tesla" },
    { label: "Model", value: "Model X" },
    { label: "Year", value: "2024" },
  ];

  const dealerInfo = [
    {
      label: "Dealer Name",
      value: (
        <strong
          className="anchor_link"
          onClick={() => navigate("/manage-dealers/detail")}
        >
          John Motors
        </strong>
      ),
    },
    { label: "Phone Number", value: "9876543210" },
    { label: "Email", value: "johnmotors@gmail.com" },
  ];

  const images = [
    "/static/images/placeholder.png",
    "/static/images/placeholder.png",
    "/static/images/placeholder.png",
  ];

  return (
    <>
      {/* Page Title */}
      <div className="main_title">
        <h1>Spare Part Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> –{" "}
          <button onClick={() => navigate("/manage-spare-parts")}>
            Listed Spare Parts
          </button>{" "}
          – Spare Part Detail
        </p>
      </div>

      {/* ================= Card 1: Spare Part Info ================= */}
      <div className="cards view_page">
        <div className="table_header mb_20">
          <h2>Spare Part Information</h2>
          <span className="status_btn dark c_success">Active</span>
        </div>

        <div className="gap_p">
          {/* Images */}
          <div className="w_100">
            <h6>Spare Part Images</h6>
            <div className="gap_p">
              {images.map((img, index) => (
                <div className="w_25" key={index}>
                  <div className="vew_img no_radius v2">
                    <figure>
                      <img src={img} className="view_img" alt="" />
                    </figure>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Spare Part Details */}
          {sparePartInfo.map((item, index) => (
            <div
              className={item.label.includes("Description") ? "w_100" : "w_33"}
              key={index}
            >
              <h6>{item.label}</h6>
              <p>{item.value}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ================= Card 2: Vehicle Compatibility ================= */}
      <div className="cards view_page mt_2">
        <div className="table_header mb_20">
          <h2>Vehicle Compatibility</h2>
        </div>

        <div className="gap_p">
          {compatibilityInfo.map((item, index) => (
            <div className="w_33" key={index}>
              <h6>{item.label}</h6>
              <p>{item.value}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ================= Card 3: Dealer Info ================= */}
      <div className="cards view_page mt_2">
        <div className="table_header mb_20">
          <h2>Dealer Information</h2>
        </div>

        <div className="gap_p">
          {dealerInfo.map((item, index) => (
            <div className="w_33" key={index}>
              <h6>{item.label}</h6>
              <p>{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ManageSparePartsDetail;